enum RemoteAccessTypeEnum {
  DAMAGE_RECORD_CREATION_BY_CUSTOMER = 'vehicleDamageRecordCreationByCustomer',
  DAMAGE_RECORD_CREATION_BY_CUSTOMER_INDIVIDUAL = 'vehicleDamageRecordCreationByCustomerIndividual',
  DAMAGE_RECORD_UPLOAD = 'vehicleDamageRecordUpload',
  DAT_MYCLAIM = 'datMyClaim',
  DSGVO = 'dsgvo',
  DSGVO_MESSAGE = 'dsgvo_message',
  SIGN_DOCUMENTS = 'signDocuments',
  SSO = 'sso'
}

export default RemoteAccessTypeEnum;
